import axiosInstance from './axiosConfig';

export const getPositionsApi = (params) => axiosInstance.get('/positions', { params });
export const getPositionApi = (id) => axiosInstance.get(`/positions/${id}`);
export const createPositionApi = (payload) => axiosInstance.post('/positions', payload);
export const updatePositionApi = (id, payload) => axiosInstance.put(`/positions/${id}`, payload);
export const deletePositionApi = (id) => axiosInstance.delete(`/positions/${id}`);

// ===== آپلود تصویر =====
export const uploadPositionImageApi = (id, file) => {
  const formData = new FormData();
  formData.append('image', file);
  return axiosInstance.post(`/positions/${id}/image`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};